import axios from 'axios'

/**
 * @desc fetches instructions for key
 */
export const fetchInstructions = (key) =>
  axios
    .get(`/authenticated/instructions`, {
      params: {
        key
      }
    })
    .then((res) => res.data)
